import { render, staticRenderFns } from "./AssetIssuance.vue?vue&type=template&id=23dd403e&scoped=true&"
import script from "./AssetIssuance.vue?vue&type=script&lang=js&"
export * from "./AssetIssuance.vue?vue&type=script&lang=js&"
import style0 from "./AssetIssuance.vue?vue&type=style&index=0&id=23dd403e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd403e",
  null
  
)

export default component.exports